"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const images_1 = require("../../../services/images");
const ProfilePictureWeb = ({ imagePath, className, width, height }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: className, style: { width, height }, children: (0, jsx_runtime_1.jsx)("img", { className: "photo", style: { width, height, borderRadius: width }, src: imagePath ? `${images_1.cloudFrontUrlAvatars + imagePath}` : images_1.icons.DefaultUser, alt: "user-photo" }) }));
};
exports.default = ProfilePictureWeb;
